import React from "react";
import { Link } from "react-router-dom";
import PageBanner from "../components/PageBanner";
import { HERO_IMAGES } from "../mock";
import { Tag, Bike, Search, Award, ChevronRight, PhoneCall } from "lucide-react";

const services = [
  {
    icon: Tag,
    title: "Car Selling",
    text: "Let us sell your classic on your behalf. We handle photography, marketing, enquiries and negotiation to achieve the very best price with none of the hassle.",
    cta: { label: "Sell your car", to: "/contact" },
  },
  {
    icon: Bike,
    title: "Motorcycles",
    text: "We buy, sell and source classic and modern-classic motorcycles — from British twins to Italian superbikes. Browse our current stock or tell us what you're after.",
    cta: { label: "View motorcycles", to: "/motorcycles" },
  },
  {
    icon: Search,
    title: "Car Sourcing",
    text: "Looking for something particular? Our network and expertise let us track down the right car at the right price, saving you time and giving you peace of mind.",
    cta: { label: "Start sourcing", to: "/car-sourcing" },
  },
  {
    icon: Award,
    title: "Classic Car Sourcing",
    text: "For the rare, the concours and the collectible, our specialist classic sourcing service finds exceptional, correctly-documented examples worthy of any collection.",
    cta: { label: "Enquire now", to: "/car-sourcing" },
  },
];

const steps = [
  { n: "01", t: "Tell us your requirements", d: "Share what you're looking to buy, sell or source." },
  { n: "02", t: "We do the legwork", d: "Marketing, inspection and negotiation handled by our team." },
  { n: "03", t: "Enjoy the result", d: "Sit back while we deliver the perfect outcome for you." },
];

const Services = () => {
  return (
    <div className="bg-white">
      <PageBanner title="Our Services" subtitle="Everything you need to buy, sell and source the finest classic cars and motorcycles." image={HERO_IMAGES[0]} />

      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.title} className="group border border-black/10 p-8 hover:shadow-xl transition-shadow flex flex-col">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full flex items-center justify-center gpm-bg-green shrink-0">
                    <Icon size={24} className="gpm-text-gold" />
                  </div>
                  <h3 className="font-serif-display text-2xl font-bold gpm-text-green">{s.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed flex-1">{s.text}</p>
                <Link to={s.cta.to} className="inline-flex items-center gap-2 mt-6 text-sm font-semibold uppercase tracking-wide gpm-text-green group-hover:gpm-text-gold transition-colors">
                  {s.cta.label} <ChevronRight size={16} />
                </Link>
              </div>
            );
          })}
        </div>
      </div>

      {/* Process */}
      <div className="gpm-bg-green py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <p className="gpm-text-gold uppercase tracking-[0.3em] text-xs mb-3">How It Works</p>
            <h2 className="font-serif-display text-3xl md:text-4xl font-bold gpm-text-cream">Simple, Trusted, Effective</h2>
            <div className="gpm-divider mx-auto mt-5" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {steps.map((s) => (
              <div key={s.n} className="text-center px-4">
                <div className="font-serif-display text-5xl font-bold gpm-text-gold mb-4">{s.n}</div>
                <h3 className="font-serif-display text-xl gpm-text-cream mb-2">{s.t}</h3>
                <p className="gpm-text-cream opacity-75 text-sm leading-relaxed">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-16 text-center">
        <h2 className="font-serif-display text-3xl font-bold gpm-text-green mb-4">Ready to get started?</h2>
        <p className="text-gray-600 mb-8">Speak to our team today about any of our services.</p>
        <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 text-sm font-semibold uppercase tracking-wider gpm-text-cream transition-transform hover:-translate-y-0.5" style={{ backgroundColor: "var(--gpm-green)" }}>
          <PhoneCall size={16} /> Contact Us
        </Link>
      </div>
    </div>
  );
};

export default Services;
